import React from 'react';
import { motion } from 'framer-motion';
import { FloatingElement } from './FloatingElement';

export function AnimatedHeroSVG() {
  return (
    <div className="relative">
      <div className="absolute inset-0 z-10 pointer-events-none">
        <motion.img
          src="https://i.ibb.co/Z1XyQL4/megaphone-front.png"
          alt="Megaphone"
          className="w-full h-full object-contain"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        />
      </div>
      <motion.svg 
        width="700" 
        height="523" 
        viewBox="0 0 595 523" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg" 
        className="w-full h-auto relative z-0"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <g clipPath="url(#clip0_460_510)">
          <path d="M283.464 440.535L265.863 435.349L270.999 453L265.863 470.601L283.464 465.465L301.115 470.601L295.93 453L301.115 435.349L283.464 440.535Z" fill="black" stroke="white" strokeMiterlimit="10"/>
        </g>
        <g clipPath="url(#clip1_460_510)">
          <path d="M469.516 353.509L438.04 370.659L469.516 387.947L486.734 419.354L503.953 387.947L535.429 370.659L503.953 353.509L486.734 321.964L469.516 353.509Z" fill="black" stroke="white" strokeMiterlimit="10"/>
        </g>

        <motion.path 
          d="M29.8827 397.333C31.7823 400.777 35.3206 403.268 40.4159 404.813C45.5137 406.359 52.1258 406.943 60.087 406.6C76.0076 405.913 97.2093 401.524 122.224 393.868C172.244 378.558 237.406 350.216 305.845 312.465C374.285 274.715 433.018 234.717 472.651 200.575C492.47 183.501 507.492 167.909 516.566 154.81C521.103 148.259 524.136 142.355 525.548 137.218C526.959 132.084 526.74 127.762 524.84 124.319C522.941 120.875 519.402 118.384 514.307 116.839C509.209 115.293 502.597 114.709 494.636 115.052C478.715 115.739 457.514 120.128 432.499 127.784C382.479 143.094 317.317 171.436 248.878 209.187C180.438 246.937 121.705 286.934 82.0724 321.077C62.253 338.15 47.2308 353.742 38.1572 366.842C33.6198 373.393 30.5865 379.297 29.1746 384.434C27.7635 389.568 27.9831 393.889 29.8827 397.333Z" 
          stroke="black"
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, ease: "easeInOut" }}
        />

        <motion.path 
          d="M50.1132 434.007C52.0128 437.451 55.5511 439.942 60.6464 441.487C65.7441 443.033 72.3562 443.617 80.3175 443.273C96.238 442.587 117.44 438.198 142.454 430.542C192.474 415.232 257.636 386.89 326.076 349.139C394.515 311.388 453.248 271.391 492.881 237.249C512.7 220.175 527.723 204.583 536.796 191.483C541.334 184.933 544.367 179.029 545.779 173.892C547.19 168.758 546.97 164.436 545.071 160.992C543.171 157.549 539.633 155.057 534.537 153.512C529.44 151.967 522.828 151.383 514.866 151.726C498.946 152.413 477.744 156.802 452.73 164.458C402.709 179.767 337.548 208.11 269.108 245.86C200.669 283.611 141.936 323.608 102.303 357.75C82.4834 374.824 67.4613 390.416 58.3877 403.516C53.8503 410.067 50.8169 415.971 49.4051 421.107C47.9939 426.241 48.2136 430.563 50.1132 434.007Z" 
          stroke="black"
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 0.5, ease: "easeInOut" }}
        />

        <motion.path 
          d="M70.3417 470.681C72.2413 474.125 75.7796 476.616 80.8749 478.161C85.9727 479.707 92.5847 480.291 100.546 479.948C116.467 479.261 137.668 474.872 162.683 467.216C212.703 451.906 277.865 423.564 346.304 385.813C414.744 348.063 473.477 308.066 513.11 273.923C532.929 256.85 547.951 241.258 557.025 228.158C561.562 221.607 564.595 215.703 566.007 210.566C567.418 205.432 567.199 201.111 565.299 197.667C563.4 194.223 559.861 191.732 554.766 190.187C549.668 188.641 543.056 188.057 535.095 188.4C519.174 189.087 497.973 193.476 472.958 201.132C422.938 216.442 357.776 244.784 289.337 282.535C220.897 320.285 162.164 360.283 122.531 394.425C102.712 411.499 87.6898 427.091 78.6162 440.19C74.0788 446.741 71.0455 452.645 69.6336 457.782C68.2225 462.916 68.4421 467.237 70.3417 470.681Z" 
          stroke="black"
          strokeWidth="2"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 2, delay: 1, ease: "easeInOut" }}
        />

        <FloatingElement duration={5} delay={1.5}>
          <circle cx="462.963" cy="112.5" r="15.5" fill="#B9FF66" stroke="black" strokeWidth="2"/>
        </FloatingElement>

        <FloatingElement duration={4} delay={1.7}>
          <circle cx="173.463" cy="443" r="10" fill="#B9FF66" stroke="black" strokeWidth="2"/>
        </FloatingElement>

        <FloatingElement duration={6} delay={1.9}>
          <circle cx="512.963" cy="72.5" r="23.5" fill="black" stroke="black" strokeWidth="2"/>
        </FloatingElement>

        <motion.g
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 2.1 }}
        >
          <path d="M360.411 81.5974C342.511 72.1937 335.588 50.1159 344.948 32.2852C354.307 14.4545 376.406 7.62311 394.306 17.0268C412.206 26.4305 419.129 48.5083 409.77 66.339C400.41 84.1697 378.311 91.0011 360.411 81.5974Z" fill="black"/>
          <path d="M394.03 41.2352C392.308 38.8849 389.763 37.4356 386.865 37.1223C384.672 36.8872 382.636 37.3573 380.718 38.5324C379.739 39.12 378.877 39.8642 378.055 40.7652C377.468 39.7075 376.763 38.7674 375.941 37.984C374.335 36.4172 372.417 35.5162 370.263 35.2812C367.366 34.9678 364.547 35.8296 362.354 37.749C360.2 39.6292 358.83 42.3712 358.478 45.4657C358.125 48.6385 358.987 51.6939 361.179 55.0626C363.137 58.0787 366.113 61.2124 369.558 64.8945C370.733 66.1479 372.064 67.5581 373.435 69.0466C373.787 69.4383 374.296 69.7125 374.844 69.7517C375.393 69.83 375.902 69.6733 376.371 69.36C378.055 68.1848 379.66 67.0881 381.07 66.1479C385.221 63.3276 388.823 60.899 391.407 58.3921C394.305 55.611 395.792 52.7906 396.145 49.6178C396.458 46.5233 395.714 43.5463 394.03 41.2352Z" fill="white"/>
        </motion.g>

        <motion.g
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 2.3 }}
        >
          <path d="M502.728 247.211C489.623 234.101 489.623 212.846 502.728 199.737C515.832 186.627 537.078 186.627 550.183 199.737C563.287 212.846 563.287 234.101 550.183 247.211C537.078 260.32 515.832 260.32 502.728 247.211Z" fill="#B9FF66"/>
          <path d="M526.461 257.892C545.413 257.892 560.879 242.458 560.879 223.46C560.879 204.502 545.452 189.029 526.461 189.029C507.471 189.029 492.044 204.462 492.044 223.46C492.044 242.419 507.471 257.892 526.461 257.892ZM526.461 190.753C544.473 190.753 559.156 205.403 559.156 223.46C559.156 241.479 544.512 256.168 526.461 256.168C508.45 256.168 493.767 241.518 493.767 223.46C493.767 205.442 508.411 190.753 526.461 190.753Z" fill="#B9FF66"/>
          <path d="M517.378 226.79C519.257 226.79 520.902 227.691 521.998 229.101L533.314 224.675C533.314 224.518 533.275 224.401 533.275 224.244C533.275 223.97 533.314 223.695 533.353 223.421L521.763 218.055C520.706 219.269 519.14 220.053 517.378 220.092C514.167 220.092 511.505 217.467 511.505 214.216C511.505 210.965 514.128 208.301 517.378 208.301C520.589 208.301 523.251 210.926 523.251 214.177C523.251 214.451 523.212 214.725 523.173 215L534.763 220.366C535.82 219.152 537.386 218.368 539.148 218.329C542.359 218.329 545.021 220.953 545.021 224.205C545.021 227.456 542.398 230.12 539.148 230.12C537.269 230.12 535.624 229.219 534.528 227.808L523.212 232.235C523.212 232.391 523.251 232.509 523.251 232.666C523.251 235.917 520.628 238.58 517.378 238.58C514.167 238.58 511.505 235.956 511.505 232.705C511.544 229.454 514.167 226.829 517.378 226.79Z" fill="black"/>
        </motion.g>

        <defs>
          <clipPath id="clip0_460_510">
            <rect width="36" height="36" fill="white" transform="matrix(-1 0 0 1 301.463 435)"/>
          </clipPath>
          <clipPath id="clip1_460_510">
            <rect width="70.3259" height="70.3259" fill="white" transform="matrix(-0.707107 0.707107 0.707107 0.707107 486.734 321)"/>
          </clipPath>
        </defs>
      </motion.svg>
    </div>
  );
}